module.exports = __webpack_public_path__ + "static/media/logo_nerima.30f166e2.png";